<template>
  <input
    :id="inputId"
    class="input"
    :type="inputType"
    :placeholder="placeholder"
    :value="value"
    @input="$emit('input', $event.target.value)"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    inputType: {
      type: String,
      default: 'text'
    },
    inputId: {
      type: String
    },
    placeholder: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.input {
  @include button-reset;

  cursor: text;

  width: 100%;
  height: 30px;
  padding: 0 28px 0 17px;
  color: #282830;
  font-family: $OpenSans;
  font-size: 12px;
  font-weight: 400;
  border-radius: 4px;
  background-color: rgb(243, 243, 243);
  box-sizing: border-box;

  &::placeholder {
    color: rgb(30, 42, 50);
    font-family: $OpenSans;
    font-size: 12px;
    font-weight: 400;
    line-height: 30px;
  }

  @include media-max($tablet-width) {
    font-size: 16px !important;
  }
}

@include media-min($tablet-width) {
  .input {
    height: 34px;
    line-height: 34px;
  }
}

@include media-min($desktop-width) {
  .input {
    height: 48px;
    font-size: 15px;
    line-height: 48px;

    &::placeholder {
      font-size: 15px;
      line-height: 48px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/_UI/BaseInput.vue